import React from "react";
import { motion } from "framer-motion";
import { Heart, ArrowRight, Link2, MessageCircle, ShieldCheck } from "lucide-react";
import { SiteHeader } from "@/components/SiteHeader";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[color:var(--brand-paper)]">
      <SiteHeader
        variant="light"
        sticky
        right={(
          <a
            href="/admin"
            data-testid="admin-access-link"
            className="inline-flex items-center gap-1.5 rounded-full border border-[color:var(--brand-border)] px-4 py-2 text-xs font-semibold uppercase tracking-[0.14em] text-[color:var(--brand-graphite)] transition-colors hover:border-[color:var(--brand-marsala)] hover:text-[color:var(--brand-marsala)]"
          >
            Área da equipe <ArrowRight className="h-3.5 w-3.5" />
          </a>
        )}
      />

      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-10 sm:px-6 lg:grid-cols-2 lg:items-center lg:py-20 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[color:var(--brand-border)] bg-white px-3 py-1 text-xs text-[color:var(--brand-muted)]">
            <Heart className="h-3.5 w-3.5 text-[color:var(--brand-marsala)]" />
            Repertório musical do seu evento
          </div>
          <h1 className="font-serif text-4xl font-semibold leading-tight tracking-tight text-[color:var(--brand-graphite)] sm:text-5xl">
            A trilha sonora do seu grande dia começa com o link da nossa equipe
          </h1>
          <p className="mt-4 max-w-md text-base leading-relaxed text-[color:var(--brand-muted)]">
            Para montar o repertório do seu evento, utilize o <strong className="font-semibold text-[color:var(--brand-graphite)]">link exclusivo</strong> enviado
            pela equipe da LC Produção. É por ele que você acessa, com segurança, o formulário do seu evento.
          </p>

          <div className="mt-8 space-y-3" data-testid="landing-steps">
            {[
              { icon: MessageCircle, title: "Receba o link", desc: "Nossa equipe envia o link do seu evento por WhatsApp." },
              { icon: Link2, title: "Preencha o repertório", desc: "Abra o link e escolha as músicas de cada momento." },
              { icon: ShieldCheck, title: "Envie uma vez", desc: "Após enviar, o repertório fica salvo com a LC. Precisa ajustar? Fale com a gente que liberamos a edição." },
            ].map((s) => (
              <div key={s.title} className="flex items-start gap-3 rounded-2xl border border-[color:var(--brand-border)] bg-white p-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[color:var(--brand-marsala-soft)]">
                  <s.icon className="h-5 w-5 text-[color:var(--brand-marsala)]" />
                </span>
                <div>
                  <p className="font-semibold text-[color:var(--brand-graphite)]">{s.title}</p>
                  <p className="mt-0.5 text-sm text-[color:var(--brand-muted)]">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 rounded-2xl border border-[color:var(--brand-border)] bg-[color:var(--brand-champagne-soft)] p-4">
            <p className="text-sm text-[color:var(--brand-graphite)]">
              Ainda não recebeu seu link? Fale com a equipe da LC Produção pelo WhatsApp e informe o nome do casal e a data do evento.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="hidden overflow-hidden rounded-3xl border border-[color:var(--brand-border)] shadow-[0_20px_60px_rgba(20,19,22,0.08)] lg:block"
        >
          <img
            src="https://images.unsplash.com/photo-1551468220-0a25172193f9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
            alt="Cerimônia de casamento"
            className="h-[560px] w-full object-cover"
          />
        </motion.div>
      </div>

      <footer className="mx-auto max-w-6xl px-4 pb-10 pt-2 text-center sm:px-6 lg:px-8">
        <p className="text-xs text-[color:var(--brand-muted)]">
          LC Produção — Transformando momentos em experiências inesquecíveis.
        </p>
      </footer>
    </div>
  );
}
